import { ReactNode, useEffect } from 'react'
import { useAuth } from '../../Hooks/Auth'
import { useNavigate } from 'react-router-dom'

interface Props {
  children: ReactNode
  permissions: string[]
  page?: boolean
}

export function Can({ children, permissions, page = false }: Props): JSX.Element | null {
  const { user } = useAuth()
  const navigate = useNavigate()


  useEffect(() => {
    if (!user || !user?.permissionsScreens?.length || !permissions?.length) {
      navigate('/denied')
      return
    }

    const hasPermission = permissions.some(permission => {
      return user.permissionsScreens.includes(permission)
    }) || user.permissionsScreens.includes('all')

    if (!hasPermission) {
      navigate('/denied')
    }
  }, [user, permissions, navigate])

  if (!user || !user?.permissions?.length) {
    return null
  }

  const hasPermission = user.permissionsScreens.some(permission => {
    return user.permissionsScreens.includes(permission)
  }) || user.permissionsScreens.includes('all')
 
  if (!hasPermission) {
    return null
  }

  if (page) {
    return <>{children}</>
  }

  return <>{children}</>
}
